import { TranslationDictionary } from '../translate/translation-dictionary.model';

export enum AnnouncementType {
  MessageBar = 0,
  ChatBubble = 1,
}

export enum AnnouncementStatus {
  Draft = 0,
  Published = 1,
}

export interface Announcement {
  id: string;
  isRemoved: boolean;
  created?: Date;
  title: TranslationDictionary;
  content: TranslationDictionary;
  type: AnnouncementType;
  status: AnnouncementStatus;
  from?: Date;
  to?: Date;
  version?: string;
  route?: string;
}
